'use client';

import { ReactNode, useRef } from 'react';

import { css } from 'styled-system/css';

import { useInView } from '@/hooks/use-in-view';

type Props = {
  /** Classes of the animation box (the observed element). */
  className: string;
  videoUrl: string;
  videoPosterUrl?: string;
  /** SSR'd poster <Image> — the stand-in until the video mounts (and the content without JS). */
  children?: ReactNode;
};

const videoClass = css({ position: 'absolute', inset: 0, w: 'full', h: 'full', objectFit: 'contain' });

// KnowhubAiSuite's `useInView` video mount as an island: the file isn't fetched during initial
// load, the <video> mounts once the box approaches the viewport (200px margin).
export const SuiteVideo = ({ className, videoUrl, videoPosterUrl, children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref);

  return (
    <div ref={ref} className={className}>
      {children}
      {isInView && (
        <video className={videoClass} autoPlay muted loop playsInline preload="metadata" poster={videoPosterUrl}>
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
    </div>
  );
};
